import Title from "../components/TheTitle.vue";
import { searchCouponBulkOperationHistory, getCouponDeletingResult, } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "CouponDetail",
    data() {
        return {
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            couponBulkOperationHistoryId: "",
            deleteHistory: {},
            selectedRows: [],
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
    },
    async created() {
        const route = this.$route;
        const codeFromParams = (route &&
            route.params &&
            route.params.couponBulkOperationHistoryId) ||
            "";
        // 優先順位は params > query
        this.couponBulkOperationHistoryId = codeFromParams || "";
        if (!this.couponBulkOperationHistoryId)
            return;
        await this.callApi(this.couponBulkOperationHistoryId);
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                return String(value);
            };
            const lines = [];
            // tableInfo から電話番号だけを1行ずつ出力（ヘッダなし）
            for (const t of this.tableInfo) {
                const num = (t.mobile_phone_number || "").replace(/-/g, "");
                lines.push(escapeCsv(num));
            }
            const csvContent = lines.join("\r\n");
            const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "クーポン付与削除結果_電話番号.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        formatDatetime(value) {
            return FormatDate.withoutTzAndMs(value);
        },
        toggleSelectAll() {
            // 表示中のみ切替ではなく、全件を対象にするか表示中のみかを切替えたい場合は別ボタンを用意する
            const phoneNum = this.tableInfo.map((r) => r.mobile_phone_number);
            const allSelected = phoneNum.every((num) => this.selectedRows.includes(num));
            if (allSelected) {
                // 全解除
                this.selectedRows = [];
            }
            else {
                // 全選択（重複除去）
                this.selectedRows = Array.from(new Set([...this.selectedRows, ...phoneNum]));
            }
        },
        async callApi(couponBulkOperationHistoryId) {
            const sCBHResponse = await searchCouponBulkOperationHistory(couponBulkOperationHistoryId);
            if (sCBHResponse.result?.code === 9) {
                this.$store.commit("setMessages", sCBHResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.deleteHistory = sCBHResponse.data.results?.[0];
            }
            const gCDRResponse = await getCouponDeletingResult(this.deleteHistory.coupon_code);
            if (gCDRResponse.result?.code === 9) {
                this.$store.commit("setMessages", gCDRResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            else {
                this.tableInfo = gCDRResponse.data.results;
                this.infoPage = 1;
            }
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
